import { ApiFailure } from 'common/types/ApiResponse';

export function hasErrorCode(data: ApiFailure, code: string) {
  return data.payload.errorInfo?.errorCode === code;
}
